import { reg_custom_components } from "./utils/result.js"


export class McInput extends HTMLElement {
  static elname = "mc-input"

  constructor() {
    super()
    this.attachShadow({ mode: "open" })
    const templ = document.createElement("template")
    templ.innerHTML = `
    <style>
      :host {
        display: flex;
        <!-- background-color: red; -->
        width: max-content;
        <!-- padding: .5rem; -->
      }

      ::slotted(input) {
        background-color: hsl(var(--mc-base));
        outline: none;
        border: 2px solid hsl(var(--mc-pine));
        padding: .5rem;
        border-radius: 5px;
        color: hsl(var(--mc-text));
        transition: all ease-in-out .250s;
      }

      ::slotted(input:focus) {
        border: 2.5px solid hsl(var(--mc-rose));
      }
    </style>
    <slot></slot>
`
    this.shadowRoot.append(templ.content.cloneNode(true))
  }


}



reg_custom_components(McInput)
